import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import React from 'react';
import { Switch, Route, generatePath } from 'react-router-dom';
import useSearchParameter from 'hooks/useSearchParameter';
import { useFetchUserAnalysisWeeks } from 'actions/users';
import { useFetchUserHubs } from 'actions/hub';
import getUserId from 'utils/session/getUserId';
import createLocation from 'utils/createLocation';
import WeekAnalysisPage from './pages/WeekAnalysisPage';
import MeetingAnalysisPage from './pages/MeetingAnalysisPage';
import SkillAnalysisPage from './pages/SkillAnalysisPage';
import WelcomePage, { HelixEmailLink, HowHelixWorksText, HelixChangeMyMindText } from './pages/WelcomePage';
import HelixNotLinkedPage from './pages/HelixNotLinkedPage';
import SummaryFlagCard from './components/SummaryFlagCard';
import NoTrackedMeetingsEmptyContent from './components/NoTrackedMeetingsEmptyContent';
import RelatedSkillContentButton from './components/RelatedSkillContentButton';
import SkillContentList from './components/SkillContentList';
function UserSkillsWidget(_ref) {
  var _data$items, _data$items2;
  var userId = _ref.userId,
    user = _ref.user,
    userAnalysisRoutes = _ref.userAnalysisRoutes;
  var _useSearchParameter = useSearchParameter('week-commencing'),
    _useSearchParameter2 = _slicedToArray(_useSearchParameter, 2),
    weekCommencing = _useSearchParameter2[0],
    setWeekCommencing = _useSearchParameter2[1];
  var isCurrentUser = Number(userId) === Number(getUserId()) || !userId;
  var _useFetchUserAnalysis = useFetchUserAnalysisWeeks({
      userId: userId
    }),
    weeks = _useFetchUserAnalysis.items,
    weeksLoading = _useFetchUserAnalysis.isLoading,
    weeksError = _useFetchUserAnalysis.isError;
  var _useFetchUserHubs = useFetchUserHubs({
      userId: userId
    }),
    isHubsLoading = _useFetchUserHubs.isLoading,
    data = _useFetchUserHubs.data;
  var currentHub = data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.find(function (hub) {
    return hub.isCurrentHub;
  });
  var helixHub = data === null || data === void 0 ? void 0 : (_data$items2 = data.items) === null || _data$items2 === void 0 ? void 0 : _data$items2.find(function (hub) {
    return hub.isHelixHub;
  });
  var isUserHelixUserInThisHub = !!(currentHub !== null && currentHub !== void 0 && currentHub.isHelixHub);
  var isLoading = weeksLoading || isHubsLoading;
  var showWelcomePage = (!weeks || weeks.length === 0) && !isLoading && isCurrentUser;
  function getUserSkillLocation(_ref2) {
    var meetingId = _ref2.meetingId,
      skillId = _ref2.skillId,
      searchSkillId = _ref2.searchSkillId;
    if (meetingId) {
      var search = {
        'week-commencing': weekCommencing
      };
      if (searchSkillId) {
        search.skillId = searchSkillId;
      }
      return createLocation(generatePath(userAnalysisRoutes.meeting, {
        meetingId: meetingId,
        userId: userId
      }), search);
    }
    if (skillId) {
      return createLocation(generatePath(userAnalysisRoutes.skill, {
        skillId: skillId,
        userId: userId
      }), {
        'week-commencing': weekCommencing
      });
    }
    return createLocation(generatePath(userAnalysisRoutes.root, {
      userId: userId
    }), {
      'week-commencing': weekCommencing
    });
  }
  if (isLoading) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: userAnalysisRoutes.skill,
    render: function render() {
      return isUserHelixUserInThisHub ? /*#__PURE__*/React.createElement(SkillAnalysisPage, {
        isCurrentUser: isCurrentUser,
        weeksLoading: weeksLoading,
        weeksError: weeksError,
        userId: userId,
        user: user,
        weekCommencing: weekCommencing === null || weekCommencing === void 0 ? void 0 : weekCommencing.toString(),
        weeks: weeks,
        setWeekCommencing: setWeekCommencing,
        getUserSkillLocation: getUserSkillLocation
      }) : /*#__PURE__*/React.createElement(HelixNotLinkedPage, {
        userId: userId,
        user: user,
        isCurrentUser: isCurrentUser,
        helixHubName: helixHub === null || helixHub === void 0 ? void 0 : helixHub.name,
        helixHubDomain: helixHub === null || helixHub === void 0 ? void 0 : helixHub.origin
      });
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: userAnalysisRoutes.meeting,
    render: function render() {
      return isUserHelixUserInThisHub ? /*#__PURE__*/React.createElement(MeetingAnalysisPage, {
        isCurrentUser: isCurrentUser,
        user: user,
        userId: userId,
        getUserSkillLocation: getUserSkillLocation
      }) : /*#__PURE__*/React.createElement(HelixNotLinkedPage, {
        userId: userId,
        user: user,
        isCurrentUser: isCurrentUser,
        helixHubName: helixHub === null || helixHub === void 0 ? void 0 : helixHub.name,
        helixHubDomain: helixHub === null || helixHub === void 0 ? void 0 : helixHub.origin
      });
    }
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: userAnalysisRoutes.root,
    render: function render() {
      return isUserHelixUserInThisHub ? showWelcomePage ? /*#__PURE__*/React.createElement(WelcomePage, {
        user: user
      }) : /*#__PURE__*/React.createElement(WeekAnalysisPage, {
        isCurrentUser: isCurrentUser,
        weeksLoading: weeksLoading,
        weeksError: weeksError,
        userId: userId,
        user: user,
        weekCommencing: weekCommencing === null || weekCommencing === void 0 ? void 0 : weekCommencing.toString(),
        weeks: weeks,
        getUserSkillLocation: getUserSkillLocation,
        setWeekCommencing: setWeekCommencing
      }) : /*#__PURE__*/React.createElement(HelixNotLinkedPage, {
        userId: userId,
        user: user,
        isCurrentUser: isCurrentUser,
        helixHubName: helixHub === null || helixHub === void 0 ? void 0 : helixHub.name,
        helixHubDomain: helixHub === null || helixHub === void 0 ? void 0 : helixHub.origin
      });
    }
  }));
}
export default UserSkillsWidget;
export { SummaryFlagCard };
export { NoTrackedMeetingsEmptyContent };
export { HelixEmailLink };
export { HowHelixWorksText };
export { HelixChangeMyMindText };
export { RelatedSkillContentButton };
export { SkillContentList };